import { Flex, Span, styled } from '@fareye/ui'
import React from 'react'
const VehicleSpan = styled(Span)`
  text-transform: uppercase;
`
export default function VehicleList({ vehicles, currentVehicle }: any) {
  const vehicleList =
    Object.values(vehicles)
      .sort((a: any, b: any) => b.sequence - a.sequence)
      .map((ele: any) => ele.vehicleNo) || []
  return (
    <Flex column>
      {vehicleList.map((ele, index) => {
        let isActive = ele === currentVehicle
        return (
          <VehicleSpan
            style={isActive ? { color: 'rgb(30,136,229)' } : {}}
            key={`${ele}-${index}`}
          >
            {ele}
          </VehicleSpan>
        )
      })}
    </Flex>
  )
}
